import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

const Login = () => {
	const [inputValue, setInputValue] = useState({
		email: "",
		password: "",
		signupEmail: "",
		signupPassword: ""
	})
	const { email, password, signupEmail, signupPassword } = inputValue;

	const googleLoginBtnRef = useRef(null)
	const googleSignupBtnRef = useRef(null)

	const handleOnChange = (e) => {
		const { name, value } = e.target
		setInputValue({
			...inputValue,
			[name]: value
		})
	}
	const handleError = (error) => {
		console.log(error)
		console.log(toast)
		toast.error(error, {
			position: "top-right"
		})
	}
	const handleSuccess = (message) =>
		toast.success(message, {
			position: "top-right"
		})

	// Google Sign-In callback
	const handleGoogleResponse = async (response) => {
		try {
			const { data } = await axios.post(
				`${process.env.REACT_APP_WEB_URL}auth/google`,
				{ credential: response.credential },
				{ withCredentials: true }
			)
			const { success, message, accountLinked } = data
			if (success) {
				if (accountLinked) {
					handleSuccess(message)
					setTimeout(() => {
						window.location.replace(`${process.env.REACT_APP_WEB_URL}`);
					}, 1500)
				} else {
					setTimeout(() => {
						window.location.replace(`${process.env.REACT_APP_WEB_URL}`);
					}, 100)
				}
			} else {
				handleError(message)
			}
		} catch (error) {
			console.log(error)
			handleError("Google login failed. Please try again.")
		}
	}

	// Load Google Identity Services script and render buttons
	useEffect(() => {
		// Make the callback available globally for Google's script
		window.handleGoogleResponse = handleGoogleResponse

		const script = document.createElement('script')
		script.src = 'https://accounts.google.com/gsi/client'
		script.async = true
		script.defer = true
		script.onload = () => {
			if (window.google) {
				window.google.accounts.id.initialize({
					client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
					callback: handleGoogleResponse,
				})
				// Render the button in the Login column
				if (googleLoginBtnRef.current) {
					window.google.accounts.id.renderButton(
						googleLoginBtnRef.current,
						{
							theme: 'outline',
							size: 'large',
							width: '100%',
							text: 'signin_with',
						}
					)
				}
				// Render the button in the Register column
				if (googleSignupBtnRef.current) {
					window.google.accounts.id.renderButton(
						googleSignupBtnRef.current,
						{
							theme: 'filled_blue',
							size: 'large',
							width: '100%',
							text: 'signup_with',
						}
					)
				}
			}
		}
		document.body.appendChild(script)

		return () => {
			// Cleanup
			delete window.handleGoogleResponse
			const existingScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]')
			if (existingScript) {
				existingScript.remove()
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const handleLoginSubmit = async (e) => {
		e.preventDefault()
		try {
			const { data } = await axios.post(
				`${process.env.REACT_APP_WEB_URL}login`,
				{ email, password },
				{ withCredentials: true }
			)
			const { success, message } = data
			if (success) {
				setTimeout(() => {
					window.location.replace(`${process.env.REACT_APP_WEB_URL}`);
				}, 100)
			} else {
				handleError(data.message || "Login failed.")
			}
		} catch (error) {
			console.log(error)
			const msg = error.response?.data?.message || "Something went wrong. Please try again."
			handleError(msg)
		}
		setInputValue({
			...inputValue,
			email: "",
			password: ""
		})
	}
	const handleSignupSubmit = async (e) => {
		e.preventDefault()
		try {
			const { data } = await axios.post(
				`${process.env.REACT_APP_WEB_URL}signup`,
				{ signupEmail, signupPassword },
				{ withCredentials: true }
			)
			const { success, message } = data
			console.log('handleSignupSubmit triggered')
			console.log(data)
			if (success) {
				console.log('handleSignupSubmit success')

				handleSuccess(message)
				setTimeout(() => {
					window.location.replace(`${process.env.REACT_APP_WEB_URL}`);
				}, 500)
			} else {
				console.log('handleSignupSubmit error')
				handleError(data.message || "Registration failed.")
			}
		} catch (error) {
			console.log(error)
			const msg = error.response?.data?.message || "Something went wrong. Please try again."
			handleError(msg)
		}
		setInputValue({
			...inputValue,
			signupEmail: "",
			signupPassword: ""
		})
	}

	return (
		<>
			<div className="login">
				<div className="login__forms">
					<div className="col-md-6 col-12">
						<div className="form__wrap">
							<h1 className="text-align--center">Log in</h1>
							<div className="google-btn-wrap" ref={googleLoginBtnRef} id="google-login-btn"></div>
							<div className="form__divider">
								<span>or</span>
							</div>
							<form onSubmit={handleLoginSubmit}>
								<div className="form__group">
									<label htmlFor="email" className="form__label">Email</label>
									<input
										className="form__input"
										type="email"
										name="email"
										value={email}
										placeholder="Email"
										onChange={handleOnChange}
									/>
								</div>
								<div className="form__group">
									<label htmlFor="password" className="form__label">Password</label>
									<input
										className="form__input"
										type="password"
										name="password"
										value={password}
										placeholder="Password"
										onChange={handleOnChange}
									/>
								</div>
								<button className="form__button" type="submit">Log in</button>
							</form>
							<Link className="form__link" to="/forgot-password">Forgot Password</Link>
						</div>
					</div>
					<div className="col-md-6 col-12">
						<div className="form__wrap">
							<h1 className="text-align--center">Register</h1>
							<div className="google-btn-wrap" ref={googleSignupBtnRef} id="google-signup-btn"></div>
							<div className="form__divider">
								<span>or</span>
							</div>
							<form onSubmit={handleSignupSubmit}>
								<div className="form__group">
									<label htmlFor="signupEmail" className="form__label">Email</label>
									<input
										className="form__input"
										type="email"
										name="signupEmail"
										value={signupEmail}
										placeholder="Email"
										onChange={handleOnChange}
									/>
								</div>
								<div className="form__group">
									<label htmlFor="signupPassword" className="form__label">Password</label>
									<input
										className="form__input"
										type="password"
										name="signupPassword"
										value={signupPassword}
										placeholder="Password (min 8 characters)"
										onChange={handleOnChange}
									/>
								</div>
								<button className="form__button form__button--primary" type="submit">Register</button>
							</form>
						</div>
					</div>
				</div>
				<div className="login__ad-section">
					<div className="ad-banner ad-banner--landscape">Possible advertising space</div>
				</div>
			</div>
			<ToastContainer />
		</>
	);
};

export default Login